import gallery from "../../api/gallery";
import { perPageCount } from "@/common/constants";
import { getApiBaseUrl } from "@/common/http.header";
import { dummyRows } from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      per_page: perPageCount,
      name: "",
      type: "all",
    },
    totalItems: 0,
    totalCount: 1,
    editItem: {},
    total: 0,
    savedTotal: 0,
    mcTotal: 0,
    listLoader: false,
    busyLoaderStatus: true,
    searchData: "",
    edited: false,
    itemLoaded: false,
  };
};

// initial state
const state = {
  ...getDefaultState(),
  imageDomain: "",
  defaultDomain: "",
  imageDomainLoading: false,
};
// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    return state.items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        image: item.image,
        html: item.html,
        type: item.type,
        cid: item.cid,
        tempImage:
          getApiBaseUrl() + "/uploads/template_images/" + item.creativeImg,
      };
    });
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    return new Promise(function (resolve) {
      var filter = state.filter;
      if (
        Object.keys(params).length > 0 &&
        (!state.loaded ||
          filter.page !== params.page ||
          filter.per_page !== params.per_page ||
          filter.name !== params.name ||
          filter.tab !== params.tab ||
          filter.type !== params.type)
      ) {
        // commit('setFilter', { ...params })
        commit("setTotalCount", 1);
        gallery.fetchItems(params, (data) => {
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setTotalCount", data.total);
          commit("setMcTotal", data.mcTotal);
          commit("setLoaded", true);
          commit("setListLoader", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      } else {
        resolve(state.total);
      }
    });
  },

  fetchImageDomain({ commit, state }) {
    return new Promise(function (resolve) {
      if (!state.imageDomain && !state.imageDomainLoading) {
        state.imageDomainLoading = true;
        gallery.fetchImageDomain((data) => {
          state.imageDomainLoading = false;
          commit("setImageDomain", data);
          resolve({ domain: data.domain, defaultDomain: data.defaultDomain });
        });
      }
    });
  },

  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },
  getSingleItem({ commit, state }, id) {
    if (!state.itemLoaded || state.editItem.id !== id) {
      commit("setItemLoaded", true);
      commit("setEditItem", { id });
      gallery.getDetails({ id }).then(function (response) {
        commit("setEditItem", { ...state.editItem, ...response.data });
      });
    }
  },
  setEditItemData({ commit }, params) {
    commit("setEditItem", params);
  },
  resetItems({ commit }) {
    commit("setItems", { items: [] });
    commit("setLoaded", false);
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

// mutations
const mutations = {
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },
  setTotalCount(state, total) {
    state.totalCount = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setEditItem(state, editItem) {
    state.editItem = editItem;
  },
  setItemLoaded(state, itemLoaded) {
    state.itemLoaded = itemLoaded;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setTotal(state, total) {
    state.total = total;
  },
  setSavedTotal(state, total) {
    state.savedTotal = total;
  },
  setMcTotal(state, total) {
    state.mcTotal = total;
  },
  setListLoader(state, loaded) {
    state.listLoader = loaded;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  setSearchData(state, search) {
    state.searchData = search;
  },
  setEdited(state, status) {
    state.edited = status;
  },
  setImageDomain(state, { domain, defaultDomain }) {
    state.imageDomain = domain;
    state.defaultDomain = defaultDomain;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
